
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".8","fill":"#282828"}},[_c('path',{attrs:{"d":"M3.617 3.125h3.978v5.451h2.812V3.125h3.978a1.406 1.406 0 100-2.813H3.617a1.406 1.406 0 000 2.813zM13.459 12.094h-8.92a1.406 1.406 0 010-2.813h8.92a1.406 1.406 0 110 2.813zM7.594 12.797v3.483a1.406 1.406 0 102.812 0v-3.483H7.594z"}})])])
          )
        }
      }
    